import React from 'react';

export const UnBlockBgIcon = (props) => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="35" height="35" rx="11" fill="#F8F9FC" />
      <g clip-path="url(#clip0_3308_3272)">
        <path
          d="M17.5 28C23.2918 28 28 23.2918 28 17.5129C28 14.7138 26.9036 12.0694 24.9042 10.0829C22.9177 8.09644 20.2862 7 17.4871 7H17.4613C11.6824 7.0129 6.9871 11.734 7 17.5129C7.0129 23.3047 11.7211 28 17.5 28ZM11.0117 11.4631C12.5983 9.76044 14.7783 8.7672 17.1259 8.66401C17.2549 8.66401 17.3839 8.65111 17.5129 8.65111C19.5252 8.65111 21.4472 9.32187 22.8016 10.4828L23.1241 10.7537L21.9502 11.9017C21.2537 12.5983 20.5442 13.2819 19.8477 13.9785C18.9189 14.8943 19.2672 15.2684 19.4865 15.4877C19.6542 15.6683 19.8219 15.7457 19.9896 15.7457C20.2733 15.7457 20.6087 15.5393 21.0344 15.1136C21.6794 14.4687 22.3114 13.8237 22.9564 13.1787L24.2205 11.9017L24.4914 12.1855C25.6265 13.4238 26.3231 15.3587 26.3489 17.3839C26.3747 19.68 25.5491 21.8471 24.0399 23.4853C22.4404 25.2138 20.2604 26.2328 17.8999 26.336C15.7328 26.4392 13.656 25.7684 12.1984 24.5172L11.8759 24.2463L12.1726 23.9496C12.4693 23.6658 12.7531 23.3821 13.0498 23.0854C13.8108 22.3501 14.5848 21.602 15.3071 20.828C15.5264 20.5958 15.7328 20.1701 15.707 19.8993C15.6812 19.6284 15.5135 19.4091 15.2684 19.3188C14.9588 19.2027 14.6106 19.2801 14.3526 19.5252C13.8366 20.0154 13.3335 20.5184 12.8305 21.0215L12.8047 21.0473C12.5983 21.2537 12.4048 21.4472 12.2113 21.6536C12.0178 21.8471 11.8501 22.0276 11.6695 22.2082C11.6308 22.2469 11.5921 22.2856 11.5534 22.3372L10.8053 23.0983L10.5731 22.8532C9.41216 21.6407 8.7027 19.6929 8.6769 17.6548C8.62531 15.32 9.46376 13.1271 11.0117 11.4631Z"
          fill="url(#paint0_linear_3308_3272)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3308_3272"
          x1="27.4643"
          y1="25.0526"
          x2="7.10433"
          y2="24.7053"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFBEA3" />
          <stop offset="1" stop-color="#D19985" />
        </linearGradient>
        <clipPath id="clip0_3308_3272">
          <rect width="21" height="21" fill="white" transform="matrix(-1 0 0 -1 28 28)" />
        </clipPath>
      </defs>
    </svg>
  );
};
